if (typeof Connect == 'undefined') Connect = { contextRoot: '/connect' };

Connect.TellusCompany = Backbone.Model.extend({
    url: function() {
        var url = Connect.contextRoot + '/tellus/' + this.integrationId + '/company';
        if (this.get('id'))
            url += '/' + this.get('id');
        return url;
    },
    defaults: {
        id: null,
        tenantId: null,
        name: null,
        daimlerToken: null,
        volvoCredentials: null, // {username}:{password}
        scaniaClientId: null,
        scaniaSecretKey: null,
        manToken: null,
    },
    
    initialize: function(options) {
        if (this.collection && this.collection.integrationId)
            this.integrationId = this.collection.integrationId;
        else if (options && options.integrationId)
            this.integrationId = options.integrationId;
    },
});

Connect.TellusCompanies = Backbone.Collection.extend({
    model: Connect.TellusCompany,

    initialize: function(options) {
        this.integrationId = options.integrationId;
    },

    url: function() {
        return Connect.contextRoot + '/tellus/' + this.integrationId + '/company';
    }
});